module.exports = __webpack_public_path__ + "img/plan.8f906e30.svg";